import React, {Component} from "react";
import Navbar from "../navbar/navbar.js";
import Space from "../space/space.js";

class Home extends Component {
    render() {
        return (
            <div>
                <Navbar/>
                <Space/>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home/home.js